<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Traffic Pelanggan</h2>

      <br />

      <p>Waktu Favorit</p>
      <ul class="waktu">
        <li :class="{ active: filter.day == 'mon' }" @click="loadData('mon')">
          Senin
        </li>
        <li :class="{ active: filter.day == 'tue' }" @click="loadData('tue')">
          Selasa
        </li>
        <li :class="{ active: filter.day == 'wed' }" @click="loadData('wed')">
          Rabu
        </li>
        <li :class="{ active: filter.day == 'thu' }" @click="loadData('thu')">
          Kamis
        </li>
        <li :class="{ active: filter.day == 'fri' }" @click="loadData('fri')">
          Jumat
        </li>
        <li :class="{ active: filter.day == 'sat' }" @click="loadData('sat')">
          Sabtu
        </li>
        <li :class="{ active: filter.day == 'sun' }" @click="loadData('sun')">
          Minggu
        </li>
      </ul>

      <table class="table">
        <thead>
          <tr>
            <th style="width: 50px">No</th>
            <th>Menu</th>
            <th>Keramaian</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ ++index }}</td>
            <td>{{ item.jam.toString().padStart(2, "0") + ":00" }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import moment from "moment";

export default {
  components: {
    DateRangePicker,
  },
  name: "Menu Favorit",
  data() {
    return {
      loading: false,
      data: [],
      filter: {
        day: moment().format("ddd").toLowerCase(),
      },
    };
  },
  methods: {
    moment,
    loadData(day) {
      this.loading = true;
      this.filter.day = day;

      api
        .get(
          "/v4/laporan/penjualan/keramaian?id_toko=" +
            this.$toko.id +
            "&day=" +
            day
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData(this.filter.day);
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .waktu {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    li {
      padding: 5px 2px;
      margin: 0 10px 20px;
      border-bottom: 2px solid #fff;
      color: #999;
      cursor: pointer;
      &.active {
        border-bottom: 2px solid var(--primary);
        color: #333;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/TrafficPelanggan.vue